import Immutable from 'immutable';

const AcademicInfoGroupRecord = Immutable.Record({
  id: undefined,
  groupName: undefined,
  groupCode: undefined,
  isTodayGroup: undefined,
});

export default class AcademicInfoGroup extends AcademicInfoGroupRecord { }



// WEBPACK FOOTER //
// ./data/AcademicInfo/AcademicInfoGroup/model.js